import { render, staticRenderFns } from "./WebKifu.vue?vue&type=template&id=e2f884de&scoped=true&"
import script from "./WebKifu.vue?vue&type=script&lang=js&"
export * from "./WebKifu.vue?vue&type=script&lang=js&"
import style0 from "./WebKifu.vue?vue&type=style&index=0&id=e2f884de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f884de",
  null
  
)

export default component.exports